// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1d5AC","header":"PatientBlock_header__1Of8j","label":"PatientBlock_label__2E0Ja","option":"PatientBlock_option__tOqvo"};